"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getColumnWidth = function (containerWidth, defaultColumnWidth, columnsCount) {
    var totalColumnWidth = defaultColumnWidth * columnsCount;
    return totalColumnWidth > containerWidth ? defaultColumnWidth : containerWidth / columnsCount;
};
exports.default = getColumnWidth;
